import "./styles.css";
import { Button, Typography } from "@mui/material";
import { sxButtonText } from "./sxProps";
import { AtestadoMedicoCardProps } from "../../../interfaces/props/SaudeOnline/AtestadoMedicoCardProps";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileContract, faPrint } from "@fortawesome/pro-duotone-svg-icons";
import { useAccessibility } from "../../../Store/contexts/AccessibilityContext";

function AtestadoMedicoCard(props: AtestadoMedicoCardProps) {
  const accessibility = useAccessibility();

  return (
    <div
      className="atestados-card-holder"
      style={{
        ...accessibility.contrastStyle,
        ...accessibility.contrastBorderAccessibility,
      }}
    >
      <div>
        <FontAwesomeIcon icon={faFileContract} className="fadt-file-contract" />
      </div>
      <div className="atestados-card-info">
        <span
          className="atestados-info"
          style={accessibility.textStyleAccessibility}
        >
          <b>{`Médico(a):`}</b> {props.atestado.nomeMedico}
        </span>
        <span
          className="atestados-info"
          style={accessibility.textStyleAccessibility}
        >
          <b>Especialidade:</b> {props.atestado.espec}
        </span>
        <span
          className="atestados-info"
          style={accessibility.textStyleAccessibility}
        >
          <b>Data:</b> {props.atestado.dtConsulta}
        </span>
        <div>
          <div>
            <Button
              sx={{padding: 0}}
              onClick={() =>
                props.handleClickImprimirAtestado(props.atestado.idAtestado)
              }
              aria-label={`Visualizar atestado de ${props.atestado.nomeMedico}, especialista em ${props.atestado.espec}, emitido em ${props.atestado.dtConsulta}`}
            >
              <FontAwesomeIcon icon={faPrint} className="fadt-print" />
              <Typography
                sx={sxButtonText}
                style={{ ...accessibility.textStyleAccessibility, color: '#00995D'}}
              >
                Visualizar atestado
              </Typography>
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AtestadoMedicoCard;
